import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'BRAR' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'BRAR', label: 'BRAR Sentiment', pane: 'sub', params: [26], outputs: ['br', 'ar'] })
